import { Injectable } from '@angular/core';
import { ID } from '@common/interfaces/id';
import { IID_OLOPOPSVLAN } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { EntityState, EntityStore } from '@datorama/akita';
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolVlanState extends EntityState<IID_OLOPOPSVLAN, ID> { }

@Injectable({ providedIn: 'root' })
@PersistedStoreConfig({ name: Topics.IID_OLO_POP_SVLAN , realtimeEntity: 'IID_OloPopSvlan'})
@InterfaceDataStore(InterfaceName.IID_OLO_POP_SVLAN)
export class IIDolVlanStore extends EntityStore<IIDolVlanState> {
  constructor() {
    super([]);
  }
}
